import React, { lazy, Suspense } from 'react';
import { Alert } from 'antd';
import I18n from 'i18n-js';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component = lazy(async () => {
  const { InlineFieldEditor } = await import('components/inline-field-editor');
  return { default: InlineFieldEditor };
});

const InlineFieldEditor = (props) => (
  <CWOConfigProvider>
    <Alert.ErrorBoundary title={I18n.t('errors.messages.failed_to_save')} description="">
      <Suspense fallback={<Loading />}>
        <Component {...props} />
      </Suspense>
    </Alert.ErrorBoundary>
  </CWOConfigProvider>
);

export default InlineFieldEditor;
